/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import HeaderContainer from '../../common/HeaderContainer/HeaderContainer'
import Container from '../../common/Container/Container'
import { UserAccountForm } from './components/UserAccount.form'
import UserAccountPicture from './components/UserAccountPicture'
import PopUp from '../../common/PopUp/PopUp'
import FileUploader from '../../common/FileUploader/FileUploader'
import { Alert } from '../../common/Alert/Alert'
import Loading from '../../common/Loading/Loading'

/**
 *     Import
 *     - Images
 */
import { UserBlueIcon } from '../../../images/icons/User/UserBlue'

/**
 *     Import
 *     - CSS
 */
import './styles/UserAccount.css'

/**
 * UserAccount class {/user/account}
 *
 * @export
 * @class UserAccount
 * @extends {React.Component<any, any>}
 */
export default class UserAccount extends React.Component<any, any> {

    /**
     * Creates an instance of UserAccount.
     *
     * @param {*} props
     * @memberof UserAccount
     */
    constructor(props: any) {
        super(props)
        this.state = {
            showPasswordPopUp: false,
            showPicturePopUp: false,
            showSavePopUp: false,
            showUploadMessage: false,
            userUpdateData: {
                user: {
                    email: null,
                    firstName: null,
                    surname: null,
                    avatar: null,
                    password: null,
                },
            },
        }
    }

    /**
     * After component mount, fetch the list of users
     *
     * @memberof UserAccount
     */
    componentWillMount() {
        this.props.fetchUserDetail()
    }

    /**
     * Before component mount, delete all possible
     * error messages
     *
     * @memberof UserAccount
     */
    componentWillUnmount() {
        this.props.userDetail.error = null
        this.props.userDetail.updated = null
    }

    /**
     * Check if there was a update
     * if yes, Trigger the fetch to return the new data
     * for showing it in the view
     *
     * @param {*} nextProps
     * @memberof UserAccount
     */
    componentWillReceiveProps(nextProps: any) {
        if (nextProps.userDetail.success === true) {
            this.props.fetchUserDetail()
        }
    }

    /**
     * Returns to the User Dasboard
     *
     * @memberof UserAccount
     */
    gotUserDasboard = () => {
        this.props.history.push('/dashboard')
    }

    /**
     * Trigger the action when clicking
     * on Change Password
     *
     * @memberof UserAccount
     */
    changePasswordAction = () => {
        this.setState({ showPasswordPopUp: !this.state.showPasswordPopUp })
    }

    /**
     * Trigger the action when clicking
     * on Change Profile Picture
     *
     * @memberof UserAccount
     */
    changePictureAction = () => {
        this.setState({ showPicturePopUp: !this.state.showPicturePopUp, showUploadMessage: false })
    }

    /**
     * Trigger the action when clicking
     * on Change Profile Picture
     *
     * @memberof UserAccount
     */
    updatePicture = () => {
        this.state.userDetail.user.avatar = this.state.userUpdateData.user.avatar
        this.changePictureAction()
    }

    /**
     * Trigger the action when clicking
     * on Save changes
     *
     * @param {*} data The data to be updated
     * @memberof UserAccount
     */
    changeSaveAction = (data) => {
        let userUpdateData = { ...this.state.userUpdateData }
        userUpdateData.user.email = data.user.email
        userUpdateData.user.firstName = data.user.firstName
        userUpdateData.user.surname = data.user.surname

        this.setState({ showSavePopUp: !this.state.showSavePopUp, userUpdateData: userUpdateData })
    }

    /**
     * Closes the save PopUp without
     * saving data
     *
     * @memberof UserAccount
     */
    closeSavePopUp = () => {
        this.setState({ showSavePopUp: !this.state.showSavePopUp })
    }

    /**
     * Update the user new data in the
     * component state
     *
     * @memberof UserAccount
     */
    sendUpdateData = () => {
        this.props.saveAccountChangesTrigger(this.state.userUpdateData)
        let userUpdateData = { ...this.state.userUpdateData }
        userUpdateData.user.password = ''
        this.setState({ userUpdateData })

        this.closeSavePopUp()
    }

    /**
     * Send an email to the user for
     * reset the password
     *
     * @memberof UserAccount
     */
    sendUpdatePassword = () => {
        this.props.forgotTrigger({ email: this.props.userDetail.userDetail.user.email })
        this.changePasswordAction()
    }

    /**
     * Will update the user new password in
     * the component state
     *
     * @param {*} event The event to get the password value from
     * @memberof UserAccount
     */
    updateUserPassword = (event) => {
        let userUpdateData = { ...this.state.userUpdateData }
        userUpdateData.user.password = event.target.value
        this.setState({ userUpdateData })

    }

    /**
     * Update the user state with the new
     * avatar in base 64
     *
     * @param {string} avatar The avatar to update in base 64
     * @memberof UserAccount
     */
    updateUserPictureData64 = (avatar: string) => {
        let userUpdateData = { ...this.state.userUpdateData }
        userUpdateData.user.avatar = avatar
        this.setState({ userUpdateData })
        this.state.userDetail.user.avatar = this.state.userUpdateData.user.avatar
        this.changePictureAction()
    }

    /**
     * Generate the error message to show
     * from the a list returned from the server
     *
     * @param {Object} object The returning object from the server with error messages
     * @memberof UserAccount
     */
    returnErrorMessages = (object) => {
        let message = ''
        for (var error in object) {
            if (error) {
                message += error.charAt(0).toUpperCase() + error.slice(1) + ' ' + object[error] + '\n'

            }
        }
        return (
            <Alert type="error">
                {message}
            </Alert>)
    }

    /**
     * Show the message from the image upload component
     *
     * @param {any} showMessage true if the message needs to be shawn
     * @memberof UserAccount
     */
    showUploadImageMessage = (showMessage: any) => {
        if (showMessage) {
            this.setState(
                { showUploadMessage: showMessage, showPicturePopUp: !this.state.showPicturePopUp }
            )
        }
    }

    render() {

        /**
         *
         * *** WIP ***
         *
         * Check if Fecth is done,
         * if Yes, set the list variables
         * if Not, return Loading
         */
        if (this.props.userDetail.done) {
            this.state.userDetail = this.props.userDetail.userDetail
        } else {
            return (<Loading />)
        }

        return (
            <div>
                {(this.state.showPasswordPopUp) ? (
                    <PopUp
                        title="Change Password Request"
                        numberButtons={2}
                        action={this.sendUpdatePassword}
                        buttonText="Change password"
                        secondaryAction={this.changePasswordAction}
                        secondaryButtonText="Cancel"
                    >
                        <a>A link with instructions to change your password will
                             be emailed to the address associated with your account.
                        </a>
                    </PopUp>
                ) : null}

                {(this.state.showPicturePopUp) ? (
                    <PopUp
                        title="Change Profile Picture"
                        action={this.changePictureAction}
                        buttonText="Cancel"
                    >
                        <div>

                            <a>Please choose a new profile picture from your device,
                                pictures should not exceeed 6MB in size.
                            </a>
                            <div className="password__center">
                                <div className="password__center__left">
                                    <div className="password__picture">
                                        <UserBlueIcon />
                                    </div>
                                </div>
                                <div className="password__center__right">
                                    <div
                                        className="password__text"
                                        onClick={this.state.actionChangePassword}
                                    >
                                        UPLOAD
                                    <FileUploader
                                        getBase64={this.updateUserPictureData64}
                                        limitedSizeAction={this.showUploadImageMessage}
                                        maxSize={6000000}
                                    />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </PopUp>
                ) : null}

                {(this.state.showSavePopUp) ? (
                    <PopUp
                        title="Verify Account Details"
                        numberButtons={2}
                        action={this.sendUpdateData}
                        buttonText="Save changes"
                        secondaryAction={this.closeSavePopUp}
                        secondaryButtonText="Cancel"
                    >
                        <a>In order to change your details please enter your password below.
                        </a>
                        <input
                            name="password"
                            id="password"
                            type="password"
                            placeholder="Enter Password"
                            onChange={this.updateUserPassword}
                        />
                    </PopUp>
                ) : null}

                <HeaderContainer
                    fullwidth={true}
                    titles={[this.state.userDetail.user.firstName + ' ' + this.state.userDetail.user.surname]}
                >
                    <div className="usersCount">{this.state.userDetail.agent.name}</div>
                </HeaderContainer>
                <Container className="addUser__form" fullwidth={false}>
                    {(this.props.userDetail.error) ?
                        this.returnErrorMessages(this.props.userDetail.error.errorMessages)
                        :
                        null}

                    {(this.props.userDetail.updated) ?
                        <Alert type="success">
                            Your profile has been updated successfully!
                        </Alert>
                        : null}

                    {(this.state.showUploadMessage) ?
                        <Alert type="warning">
                            Invalid file: images must be less than 6MB in JPG or PNG format.
                    </Alert>
                        : null}

                    <UserAccountPicture
                        avatar={this.state.userDetail.user.avatar}
                        actionChangePassword={this.changePasswordAction}
                        actionChangePicture={this.changePictureAction}
                    />
                    <UserAccountForm
                        errorState={this.props.errorState}
                        saveAccountChangesTrigger={this.changeSaveAction}
                        goBack={this.gotUserDasboard}
                        email={this.state.userDetail.user.email}
                        firstName={this.state.userDetail.user.firstName}
                        surname={this.state.userDetail.user.surname}
                    />
                </Container>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/UserAccount/UserAccount.tsx